// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconSolanatestnet } from "../../../icons/mono/build/icon-solanatestnet.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SolanatestnetIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconSolanatestnet.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SolanatestnetIcon.displayName = 'SolanatestnetIcon';
}

export default SolanatestnetIcon;